﻿package com.mgacreative.hotel.core.notifications.domain

enum class ChannelType {
    PUSH, EMAIL, SMS, WHATSAPP
}

data class NotificationPreferences(
    val pushEnabled: Boolean = true,
    val emailEnabled: Boolean = true,
    val smsEnabled: Boolean = true,
    val whatsappEnabled: Boolean = false
)

interface NotificationChannel {
    val type: ChannelType
    suspend fun send(recipient: String, title: String, body: String): Boolean
}

interface NotificationPreferencesRepository {
    suspend fun getPreferences(userId: String): NotificationPreferences
    suspend fun savePreferences(userId: String, prefs: NotificationPreferences)
}
